import { forwardRef } from "react";
import {
  DatePicker as MuiDatePicker,
  DatePickerProps,
  DatePickerSlotsComponentsProps,
  DateValidationError
} from "@mui/x-date-pickers";
import { Box } from "@mui/material";
import merge from "lodash/merge";

type SlotProps = DatePickerSlotsComponentsProps<any>;
export type Sizes = "small" | "medium" | "large";

export interface Props extends Omit<DatePickerProps<any>, "value"> {
  ariaLabel?: string;
  clearable?: boolean;
  "data-qa"?: string;
  date: Date | null;
  disableFuture?: boolean;
  fullWidth?: boolean;
  id?: string;
  label?: string;
  slotProps?: SlotProps;
  helperText?: string;
  size?: Sizes;
  onError?: (error: DateValidationError | null) => void;
}

export const DatePicker = forwardRef<HTMLInputElement, Props>(
  (
    {
      ariaLabel,
      clearable = false,
      date,
      disableFuture = true,
      fullWidth = true,
      id = "",
      label,
      onChange,
      helperText,
      slotProps,
      size = "small",
      onError,
      ...restProps
    },
    ref
  ) => {
    return (
      <Box
        sx={{ display: "contents !important" }}
        data-qa={restProps["data-qa"]}
      >
        <MuiDatePicker
          label={label}
          value={date}
          onChange={onChange}
          onError={onError}
          slotProps={merge(
            slotProps as SlotProps,
            {
              textField: {
                "aria-label": ariaLabel ?? "date time input field",
                helperText: helperText,
                clearable,
                fullWidth,
                id,
                size
              }
            } as SlotProps
          )}
          disableFuture={disableFuture}
          inputRef={ref}
          {...restProps}
        />
      </Box>
    );
  }
);
DatePicker.displayName = "AppDatePicker";
